import React from 'react'
import styled from 'styled-components'
import Typography from '@/v2/components/common/Typography'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'

const Cell = styled.div`
  display: flex;
  flex-direction: column;
`

const PaidWith = ({ invoice, variant = 'desktop' }) => {
  const theme = useTheme()
  const isMobile = variant === 'mobile'
  const valueFontSize = isMobile ? '14px' : '15px'
  const labelLineHeight = isMobile ? '18px' : '23px'
  const filteredSet = new Set()

  invoice.payments.forEach(payment => {
    if (payment.paymentMethod === 'credit_card') {
      filteredSet.add(`Card (${payment.last4})`)
    } else if (payment.paymentMethod === 'ach') {
      filteredSet.add(`ACH (${payment.last4})`)
    } else {
      filteredSet.add(payment.paymentMethod)
    }
  })

  const content = (
    <>
      <Typography
        fontSize="10px"
        lineHeight={labelLineHeight}
        color={theme.palette.gray.dark}
      >
        PAID WITH
      </Typography>
      <Cell>
        {Array.from(filteredSet).length === 0 ? (
          <Typography fontSize={valueFontSize}>None</Typography>
        ) : (
          Array.from(filteredSet).map((method, index) => (
            <Typography
              fontSize={valueFontSize}
              key={`payment-method-index-${index}`}
              sx={{ textTransform: 'capitalize' }}
            >
              {method}
            </Typography>
          ))
        )}
      </Cell>
    </>
  )

  return isMobile ? (
    <div>{content}</div>
  ) : (
    <Grid item xs={1}>
      {content}
    </Grid>
  )
}

export default PaidWith
